import { CREATE_DMX_PROFILE, CREATE_DMX_PROFILE_SUCCESSFUL, CREATE_DMX_PROFILE_FAILED } from './actionTypes';

const initialState = {
  createDmxProfileError: null,
  messageDmxProfile: null,
  loadingCreateDmxProfile: false,
};

const createProfile = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_DMX_PROFILE:
      state = { ...state, loadingCreateDmxProfile: true, createDmxProfileError: null };
      break;
    case CREATE_DMX_PROFILE_SUCCESSFUL:
      state = { ...state, loadingCreateDmxProfile: false, messageDmxProfile: action.payload, createDmxProfileError: null };
      break;
    case CREATE_DMX_PROFILE_FAILED:
      state = { ...state, messageDmxProfile: null, loadingCreateDmxProfile: false, createDmxProfileError: action.payload };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default createProfile;
